import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Layout from "./ui/pages/layout/Layout";
import routes from "./routes";

export default class App extends Component {
    displayName = App.name;

    state = { recaptchaKey: null };

    render() {
        return (
          <SnackbarProvider maxSnack={3}>
              <Layout>
                  <Switch>
                      {
                          routes.map((route, index) => (
                            <Page key={index} exact={route.exact || false} path={route.path} component={route.component} title={route.title || "Geolux"} metaTags={route.metaTags || []} />
                          ))
                      }
                      <Route render={() => <Redirect to="/" />} />
                  </Switch>
              </Layout>
          </SnackbarProvider>
        );
    }
}

class Page extends Component {
    appendCustomMetaTag = (metaTag) => {
        let element = document.createElement("meta");
        element.setAttribute("controlled-meta-tag", "");
        for (var attribute in metaTag) {
            element.setAttribute(attribute, metaTag[attribute]);
        }
        document.head.appendChild(element);
    }

    removeCustomMetaTags = () => {
        let metaTags = document.querySelectorAll("[controlled-meta-tag]");
        metaTags.forEach(metaTag => document.head.removeChild(metaTag));
    }

    onMatch = ({ match }) => {
        let { component: Component, title, metaTags } = this.props;

        if (match) {
            document.title = title;
            this.removeCustomMetaTags();
            metaTags.forEach(this.appendCustomMetaTag);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }

        return <Component />;
    }

    render() {
        let { component: Component, ...rest } = this.props;
        return <Route children={this.onMatch} {...rest} />;
    }
}